<template>
    <div class="simple-form">
        <div class="form-group center">
            <div class="form-label ">
                <label class="required">常规服务项</label>
            </div>
            <div class="form-value">
                <span><a class="ml10" style="color: blue;" @click="selectShopComnRepair">选择</a> <a class="ml10 fr">已选择({{shopComnRepairList.length}})</a></span>
                <div class="table-layout">
                    <el-table :data="shopComnRepairList" border height="250" tooltip-effect="dark">
                        <el-table-column prop="title" label="名称"></el-table-column>
                        <el-table-column prop="servcCatName" label="服务分类"></el-table-column>
                        <el-table-column prop="creatorName" label="创建人"></el-table-column>
                        <el-table-column prop="postName" label="操作">
                            <template slot-scope="rows">
                                <el-button type="text" @click="deleteDevice(rows.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label ">
                <label class="required">服务商</label>
            </div>
            <div class="form-value">
                <swb-shop-comn-repair-servicer :showRepair="showRepair" :add="true" :servcCatId="servcCatId" ref="swb_shop_device_servicer"></swb-shop-comn-repair-servicer>
            </div>
        </div>

    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { openShopComnRepairSelecrtPageDlg } from './dialog'

    import SwbShopComnRepairServicerList from './ShopComnRepairServicerList'
    Vue.regist(SwbShopComnRepairServicerList);

    export default {
        name: 'swb-shop-comn-repair-list-servicer-select',
        avlScopes: 'vendor',
        desc: '常规服务请求设置默认服务商',
        props: {
            bizUnitId: {
                type: Number,
                default: null
            },
        },
        data: function () {
            return {
                deviceIds: [],
                shopDeviceServicerDto: {},
                shopComnRepairList: [],
                showRepair: false,
                servcCatId: null
            }
        },
        created: function () {
        },
        methods: {
            selectShopComnRepair: function () {
                let self = this;
                let shopComnRepairList = Utils.merge([], self.shopComnRepairList);
                let checkedIds = shopComnRepairList.pluck("id");
                let params = {
                    bizUnitId: self.bizUnitId,
                    checkedIds: checkedIds,
                    checkBox: true
                };
                openShopComnRepairSelecrtPageDlg(params, function (result) {
                    let selectShopComnRepairList = result || [];
                    let deviceList = shopComnRepairList.concat(selectShopComnRepairList);
                    // 必须是相同服务分类
                    // 必须是相同服务分类
                    let servcCatId = null;
                    let err = false;
                    for(let i = 0; i < deviceList.length; i++) {
                        let item = deviceList[i];
                        if(i == 0) {
                            servcCatId = item.servcCatId;
                        } else if(item.servcCatId != servcCatId) {
                            err = true;
                            break;
                        }
                    }
                    if(err) {
                        self.$message.warning('请选择相同服务分类的服务项');
                    } else {
                        self.servcCatId = servcCatId;
                        self.shopComnRepairList = Utils.merge([], deviceList);
                        self.showRepair = true;
                    }
                })

            },
            deleteDevice: function (row) {
                let self = this;
                this.$confirm("确定删除常规服务【" + row.title + "】？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let shopComnRepairList = self.shopComnRepairList || [];
                    for(let i = 0; i < shopComnRepairList.length; i++) {
                        let shopComnRepair = shopComnRepairList[i];
                        if(shopComnRepair.id == row.id) {
                            shopComnRepairList.splice(i, 1);
                            break;
                        }
                    }
                    if(shopComnRepairList.length <= 0) {
                        self.showRepair = false;
                        self.servcCatId = null;
                    }
                    self.shopComnRepairList = Utils.merge([], shopComnRepairList);
                }).catch(function () {
                });

            },
            getDlgResult: function () {
                let self = this;
                let result = {};

                let shopComnRepairList = self.shopComnRepairList;
                let repairIds = shopComnRepairList.pluck("id");
                let deviceServicerList = [];
                let resultServicer = self.$refs.swb_shop_device_servicer.getDlgResult() || {};
                if(resultServicer.type == "info") {
                    deviceServicerList = resultServicer.data;
                } else {
                    result.message = resultServicer.message;
                    result.type = "warn";
                    return result;
                }
                let shopComnRepairServicerDto = {};
                shopComnRepairServicerDto.repairIds = repairIds;
                shopComnRepairServicerDto.shopComnRepairServicerList = deviceServicerList;
                result.type = "info";
                result.data = shopComnRepairServicerDto;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shopComnReq/ShopComnRepairServicerPageList.vue